import React from "react";

export const ApiContext = React.createContext();

export const ApiContextProvider = ApiContext.Provider;

export function withApi(Component) {
  return function ApiContextComponent(props) {
    return <ApiContext.Consumer>{api => <Component {...props} api={api} />}</ApiContext.Consumer>;
  };
}

export function useApi() {
  const context = React.useContext(ApiContext);
  if (!context) {
    throw new Error("useApi must be used within an ApiContextProvider");
  }
  return context;
}
